var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.2767 3.89973C14.4587 1.71273 17.9797 1.31773 20.4117 3.21973C23.3247 5.49773 23.5157 9.74273 20.9847 12.2797L19.5617 13.7047C19.1687 14.0987 18.5327 14.0987 18.1397 13.7047C17.7467 13.3117 17.7467 12.6727 18.1397 12.2797L19.5617 10.8537C21.2167 9.19673 21.1267 6.44173 19.2897 4.90373C17.6627 3.54073 15.2207 3.80073 13.7217 5.30273L12.4487 6.57773C12.0567 6.97173 11.4187 6.97173 11.0267 6.57773C10.6337 6.18473 10.6297 5.54973 11.2037 4.97473L12.2767 3.89973ZM14.0426 9.29303L10.0426 13.293C9.65164 13.684 9.65164 14.316 10.0426 14.707C10.2376 14.902 10.4936 15 10.7496 15C11.0056 15 11.2616 14.902 11.4566 14.707L15.4566 10.707C15.8476 10.316 15.8476 9.68403 15.4566 9.29303C15.0656 8.90203 14.4336 8.90203 14.0426 9.29303ZM13.0299 17.3965L11.7559 18.6675C10.2549 20.1645 7.80794 20.4225 6.17994 19.0655C4.34094 17.5335 4.24994 14.7875 5.90694 13.1345L7.33193 11.7145C7.72494 11.3225 7.72494 10.6865 7.33193 10.2935C6.93893 9.90253 6.30094 9.90253 5.90694 10.2935L4.63194 11.5665C2.45994 13.7325 2.07894 17.2165 3.95694 19.6405C6.22794 22.5735 10.4879 22.7715 13.0299 20.2375L14.4549 18.8175C14.8479 18.4245 14.8479 17.7895 14.4549 17.3965C14.0609 17.0035 13.4239 17.0035 13.0299 17.3965Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLink);
export default __webpack_public_path__ + "static/media/Link.818874d533428a5ad9e9282f5e5572cb.svg";
export { ForwardRef as ReactComponent };